
import React from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { DialogFooter } from "@/components/ui/dialog";
import { ImageUpload } from "@/components/ui/image-upload";
import { Club } from "@/types/database-extensions";

type ClubFormProps = {
  currentClub: Partial<Club>;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSubmit: (e: React.FormEvent) => Promise<void>;
  isSubmitting: boolean;
  setIsDialogOpen: (open: boolean) => void;
  handleImageChange?: (url: string) => void;
};

const ClubForm = ({
  currentClub,
  handleInputChange,
  handleSubmit,
  isSubmitting,
  setIsDialogOpen,
  handleImageChange,
}: ClubFormProps) => {
  return (
    <form onSubmit={handleSubmit} className="space-y-4 pt-4">
      <div className="space-y-2">
        <label htmlFor="name" className="text-sm font-medium">
          Name *
        </label>
        <Input
          id="name"
          name="name"
          value={currentClub.name || ""}
          onChange={handleInputChange}
          required
        />
      </div>

      <div className="space-y-2">
        <label htmlFor="category" className="text-sm font-medium">
          Category *
        </label>
        <Input
          id="category"
          name="category"
          value={currentClub.category || ""}
          onChange={handleInputChange}
          required
          placeholder="e.g. STEM, Arts, Leadership"
        />
      </div>

      {handleImageChange && (
        <div className="space-y-2">
          <label className="text-sm font-medium">Club Logo</label>
          <div className="flex justify-center">
            <ImageUpload
              value={currentClub.logo_url}
              onChange={handleImageChange}
              size="lg"
            />
          </div>
        </div>
      )}

      <div className="space-y-2">
        <label htmlFor="description" className="text-sm font-medium">
          Description *
        </label>
        <Textarea
          id="description"
          name="description"
          rows={4}
          value={currentClub.description || ""}
          onChange={handleInputChange}
          required
        />
      </div>

      <div className="space-y-2">
        <label htmlFor="meeting_schedule" className="text-sm font-medium">
          Meeting Schedule
        </label>
        <Input
          id="meeting_schedule"
          name="meeting_schedule"
          value={currentClub.meeting_schedule || ""}
          onChange={handleInputChange}
          placeholder="e.g. Every Monday at 4pm"
        />
      </div>

      <DialogFooter>
        <Button
          type="button"
          variant="outline"
          onClick={() => setIsDialogOpen(false)}
        >
          Cancel
        </Button>
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          {currentClub.id ? "Update" : "Create"}
        </Button>
      </DialogFooter>
    </form>
  );
};

export default ClubForm;
